module.exports = __webpack_public_path__ + "img/bell.07e11e85.svg";